import axiosInstance from "../instance/axiosInstance";

class FileUploadApi {
  static async getPresignedUrl(formData) {
    try {
      const response = await axiosInstance.post("/generate-presigned-url", formData);
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async finalizeUpload(formData) {
    try {
      const response = await axiosInstance.post("/finalize-upload", formData);
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async uploadFile(formData, onUploadProgress) {
    try {
      const response = await axiosInstance.post("/upload-file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: onUploadProgress,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
}
export default FileUploadApi